/** @param {*} value */
function isEmpty(value) {
	return value === null || value === undefined || String(value).trim() === '';
}

/** Empty values go last; numbers inside text compare numerically ("ק.2" before "ק.10"). */
function compareText(a, b) {
	if (isEmpty(a) && isEmpty(b)) return 0;
	if (isEmpty(a)) return 1;
	if (isEmpty(b)) return -1;
	return String(a).localeCompare(String(b), undefined, { numeric: true, sensitivity: 'base' });
}

/** Numeric floors ("-1", "0", "10") compare as numbers and come before non-numeric ones. */
function compareFloor(a, b) {
	const aNum = isEmpty(a) ? NaN : Number(a);
	const bNum = isEmpty(b) ? NaN : Number(b);
	const aIsNum = Number.isFinite(aNum);
	const bIsNum = Number.isFinite(bNum);
	if (aIsNum && bIsNum) return aNum - bNum;
	if (aIsNum) return -1;
	if (bIsNum) return 1;
	return compareText(a, b);
}

/**
 * Orders rooms by building, then floor, then room name.
 * @param {{ building?: string; floor?: string | number; room_name?: string }} a
 * @param {{ building?: string; floor?: string | number; room_name?: string }} b
 * @returns {number}
 */
export function compareRoomLocation(a, b) {
	return compareText(a.building, b.building)
		|| compareFloor(a.floor, b.floor)
		|| compareText(a.room_name, b.room_name);
}
